/* Pack Character Builder — vide les champs quand on crée un NOUVEAU personnage secondaire. */
(function () {
  var IDS = ['pbPrenom', 'pbAge', 'pbReves', 'pbAnecdotes', 'pbDedicace', 'pbLien'];
  function clearFields() {
    IDS.forEach(function (id) { var el = document.getElementById(id); if (el) el.value = ''; });
  }
  function roleIsSecondary() {
    var t = document.getElementById('pbCharTitle');
    return !!(t && /secondaire/i.test(t.textContent || ''));
  }
  var prevSecondary = false;
  function check() {
    var now = roleIsSecondary();
    if (now && !prevSecondary) { clearFields(); setTimeout(clearFields, 0); }
    prevSecondary = now;
  }
  function init() {
    var titleEl = document.getElementById('pbCharTitle');
    var stepEl  = document.getElementById('pbStepChar');
    if (titleEl) new MutationObserver(check).observe(titleEl, { childList: true, characterData: true, subtree: true });
    if (stepEl)  new MutationObserver(check).observe(stepEl,  { attributes: true, attributeFilter: ['class'] });
    check();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* ── Couvertures : une seule vidéo partagée + liste compacte d'options ── */
(function () {
  var VIDEO_URL = 'https://cdn.shopify.com/videos/c/o/v/751c87c27626448c8a861aac9bcb1701.mp4';

  var style = document.createElement('style');
  style.textContent = [
    '.pb-cover-video-shared { width:100%; max-width:380px; margin:0 auto 10px; border-radius:14px; overflow:hidden; border:1.5px solid #C1E5F1; aspect-ratio:16/10; }',
    '.pb-cover-video-shared video { width:100%; height:100%; object-fit:contain; display:block; }',
    '.pb-cover-grid.pb-cover-grid--compact { display:grid !important; grid-template-columns:repeat(3, 1fr) !important; gap:8px !important; margin-bottom:14px; }',
    '.pb-cover-grid--compact .pb-cover-card { display:flex; flex-direction:column; align-items:center; justify-content:center; padding:12px 6px; text-align:center; gap:3px; }',
    '.pb-cover-grid--compact .pb-cover-card:hover { border-color:#C1E5F1; transform:translateY(-2px); box-shadow:0 4px 14px rgba(193,229,241,0.3); }',
    '.pb-cover-grid--compact .pb-cover-card-text { display:flex; flex-direction:column; align-items:center; gap:2px; }',
    '.pb-cover-grid--compact .pb-cover-badge { display:inline-block; width:auto; margin-bottom:1px; font-size:8px; padding:2px 7px; }',
    '.pb-cover-grid--compact .pb-cover-card-label { font-size:12px; }',
    '.pb-cover-grid--compact .pb-cover-card-desc { font-size:8px; }',
    '.pb-cover-grid--compact .pb-cover-check { display:none; }'
  ].join('\n');
  document.head.appendChild(style);

  var LABEL_MAP = {
    'Rigide 20x20':  '20×20 cm',
    'Souple 14x14':  '14×14 cm',
    'Souple 20x20':  '20×20 cm'
  };

  var DESC_MAP = {
    'Rigide 20x20':  'Solide et durable',
    'Souple 14x14':  'Léger et pratique',
    'Souple 20x20':  'Grand format souple'
  };

  function updateTexts(card) {
    var coverType = (card.getAttribute('data-pb-cover') || '').trim();

    var labelEl = card.querySelector('.pb-cover-card-label');
    var newLabel = LABEL_MAP[coverType] || coverType;
    if (labelEl && labelEl.textContent !== newLabel) labelEl.textContent = newLabel;

    var descEl = card.querySelector('.pb-cover-card-desc');
    var newDesc = DESC_MAP[coverType];
    if (descEl && newDesc && descEl.textContent !== newDesc) descEl.textContent = newDesc;

    var badgeEl = card.querySelector('.pb-cover-badge');
    if (badgeEl) {
      badgeEl.style.background = coverType.indexOf('Souple') !== -1 ? '#8ECFE8' : '#3A9DB8';
      badgeEl.style.color = 'white';
    }
  }

  function buildCompactLayout() {
    var stepCover = document.getElementById('pbStepCover');
    if (!stepCover) return;
    var grid = stepCover.querySelector('.pb-cover-grid');
    if (!grid) return;

    if (!stepCover.querySelector('.pb-cover-video-shared')) {
      var vid = document.createElement('div');
      vid.className = 'pb-cover-video-shared';
      vid.innerHTML = '<video autoplay loop muted playsinline><source src="' + VIDEO_URL + '" type="video/mp4"></video>';
      grid.parentNode.insertBefore(vid, grid);

      var videoEl = vid.querySelector('video');
      if (videoEl) {
        var tryPlay = function () { videoEl.play().catch(function () {}); };
        var syncAspect = function () {
          if (videoEl.videoWidth && videoEl.videoHeight) {
            vid.style.aspectRatio = videoEl.videoWidth + '/' + videoEl.videoHeight;
          }
        };
        tryPlay();
        videoEl.addEventListener('loadedmetadata', function () { syncAspect(); tryPlay(); });
        videoEl.addEventListener('canplay', tryPlay);
      }
    }

    grid.classList.add('pb-cover-grid--compact');

    grid.querySelectorAll('.pb-cover-card').forEach(function (card) {
      updateTexts(card);
      if (card.dataset.pbCompact) return;
      card.dataset.pbCompact = '1';

      var icon = card.querySelector('.pb-cover-icon');
      if (icon) icon.remove();

      var badge = card.querySelector('.pb-cover-badge');
      var label = card.querySelector('.pb-cover-card-label');
      var desc  = card.querySelector('.pb-cover-card-desc');

      var text = document.createElement('div');
      text.className = 'pb-cover-card-text';
      if (badge) text.appendChild(badge);
      if (label) text.appendChild(label);
      if (desc) text.appendChild(desc);
      card.appendChild(text);

      var check = document.createElement('div');
      check.className = 'pb-cover-check';
      card.appendChild(check);
    });
  }

  function init() {
    buildCompactLayout();
    var cover = document.getElementById('pbStepCover');
    if (cover) new MutationObserver(buildCompactLayout).observe(cover, { attributes: true, attributeFilter: ['class'] });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
